module.exports = __webpack_public_path__ + "static/media/take_1.9809913f.mp3";